import { Dialog } from "@radix-ui/themes";
import XCircle from "../../../../assets/images/XCircle.png";
import X from "../../../../assets/images/x.png";
import profileSuccess from "../../../../assets/images/profileSuccess.png";

interface SuccessProps {
    visible:boolean;
    onRequestClose:any;
    onPress:any;
    message:any;
    type?:any
}

const SuccessModal = ({ visible, onRequestClose, onPress, message, type }:SuccessProps) => {
  return (
    <Dialog.Root open={visible} onOpenChange={onRequestClose}>
      <Dialog.Content className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center rounded-t-[4%]">
        {type === 'profile' ? (
          <div className="bg-white mx-[3%] rounded-[20px] flex flex-col items-center py-[1%] w-[70%]">
            <button
              className="absolute top-[10px] right-[10px]"
              onClick={onRequestClose}
            >
              <img
                src={X}
                alt="Close"
                className="object-contain"
                style={{ height: '20px', width: '20px', filter: 'hue-rotate(0deg) saturate(0%) brightness(0%)' }}
              />
            </button>
            <img
              src={profileSuccess}
              alt="Profile Success"
              className="object-contain mt-[-4.5%]"
              style={{ height: '11%', width: '11%' }}
            />
            <span
              className="text-black text-lg font-bold text-center px-[6%] pb-[1%] mt-[2%]"
              style={{ fontFamily: "'Lato', sans-serif" }}
            >
              Profile photo updated
            </span>
            <span
              className="text-black text-sm font-medium text-center px-[6%] pb-[1%] mt-[2%]"
              style={{ fontFamily: "'Lato', sans-serif" }}
            >
              Your profile photo has been updated successfully
            </span>
            <button
              onClick={onPress}
              className="bg-gradient-to-r from-[#363E70] to-[#A458BA] rounded-[20px] px-[5%] py-[1%] my-[1%]"
            >
              <span
                className="text-white text-sm font-bold"
                style={{ fontFamily: "'Lato', sans-serif", lineHeight: '20px' }}
              >
                Done
              </span>
            </button>
          </div>
        ) : (
          <div className="bg-white mx-[3%] rounded-[20px] flex flex-col items-center py-[1%] w-[70%]">
            <div
              className="bg-[#E9BE50] border-4 border-white rounded-full flex items-center justify-center h-[11%] w-[11%] mt-[-4.5%] shadow-md"
              style={{
                boxShadow: '0 3px 4.65px rgba(23, 23, 23, 0.27)',
              }}
            >
              <img
                src="/assets/messageSquare.png"
                alt="Message"
                className="object-contain"
                style={{ height: '5%', width: '5%' }}
              />
            </div>
            <span
              className="text-black text-sm font-medium text-center px-[6%] pb-[1%] mt-[2%]"
              style={{ fontFamily: "'Lato', sans-serif" }}
            >
              {message}
            </span>
            <button
              onClick={onPress}
              className="bg-gradient-to-r from-[#363E70] to-[#A458BA] rounded-[20px] px-[5%] py-[1%] my-[1%]"
            >
              <span
                className="text-white text-sm font-bold"
                style={{ fontFamily: "'Lato', sans-serif", lineHeight: '20px' }}
              >
                Ok
              </span>
            </button>
          </div>
        )}
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default SuccessModal;